<iframe id="iframePrescriptionMapNdvi" width="100%" [height]="mapHeight" title="Maps"></iframe>
